import { BaseFilterDropdown } from './BaseFilterDropdown';
import { RangeSlider } from './RangeSlider';

type FilterDropdownRangeProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  values: [number, number];
  onChange: (values: [number, number]) => void;
  min?: number;
  max?: number;
  step?: number;
};

export function FilterDropdownRange({
  title,
  isOpen,
  onToggle,
  values,
  onChange,
  min = 0,
  max = 100,
  step = 1,
}: FilterDropdownRangeProps) {
  return (
    <BaseFilterDropdown
      title={title}
      isOpen={isOpen}
      onToggle={onToggle}
      selectedCount={values[0] !== min || values[1] !== max ? 1 : 0}
    >
      <div className="py-[8px] px-[12px]">
        <RangeSlider min={min} max={max} step={step} values={values} onChange={onChange} />
      </div>
    </BaseFilterDropdown>
  );
}
